var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "523px",
    height: "470px",
    viewBox: "0 0 523 470",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BlueprintLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.5723101,7 L491,7 L491,477 L366.926937,477 L253.620642,280.747742 C266.429251,273.05556 275,259.028683 275,243 C275,218.699471 255.300529,199 231,199 C223.239964,199 215.949123,201.008864 209.61915,204.534921 L95.5723101,7 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 231,
    cy: 243,
    r: 44
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blueprint-w/-Background",
    transform: "translate(0.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(32.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00D8FF",
    strokeWidth: 23,
    transform: "translate(229.500000, 241.500000) rotate(90.000000) translate(-229.500000, -241.500000) ",
    cx: 229.5,
    cy: 241.5,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00D8FF",
    strokeWidth: 23,
    transform: "translate(229.500000, 242.500000) rotate(30.000000) translate(-229.500000, -242.500000) ",
    cx: 229.5,
    cy: 242.5,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00D8FF",
    strokeWidth: 23,
    transform: "translate(229.661197, 242.002830) rotate(-30.000000) translate(-229.661197, -242.002830) ",
    cx: 229.661197,
    cy: 242.00283,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#00D8FF",
    cx: 231,
    cy: 244,
    r: 44
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    mask: "url(#mask-2)",
    strokeDasharray: "2,8",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H-Lines",
    transform: "translate(65.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351,0 L351,488",
    id: "Line",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,0 L316,488",
    id: "Line-Copy-8",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.25,0 L281.25,488",
    id: "Line-Copy-7",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,0 L246,488",
    id: "Line",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,0 L211,488",
    id: "Line-Copy-6",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,0 L176,488",
    id: "Line-Copy-5",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,0 L176,488",
    id: "Line-Copy-4",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,0 L141,488",
    id: "Line-Copy-3",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,0 L106,488",
    id: "Line-Copy-2",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L71,488",
    id: "Line",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,0 L36,488",
    id: "Line",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L1,488",
    id: "Line-Copy",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "V-Lines",
    transform: "translate(224.500000, 248.500000) rotate(90.000000) translate(-224.500000, -248.500000) translate(-4.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.5,449 L421.5,0.5",
    id: "Line-2-Copy-5",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.5,449 L456.5,0.5",
    id: "Line-2-Copy-12",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,449 L386.5,0.5",
    id: "Line-2-Copy-11",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,449 L351.5,0.5",
    id: "Line-2-Copy-10",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5,449 L316.5,0.5",
    id: "Line-2-Copy-9",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5,449 L281.5,0.5",
    id: "Line-2-Copy-8",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,449 L245.5,0.5",
    id: "Line-2-Copy-7",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,449 L210.5,0.5",
    id: "Line-2-Copy-6",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,449 L175.5,0.5",
    id: "Line-2-Copy-4",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,449 L140.5,0.5",
    id: "Line-2-Copy-3",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5,449 L105.5,0.5",
    id: "Line-2-Copy-2",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,449 L70.5,0.5",
    id: "Line-2-Copy",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,449 L35.5,0.5",
    id: "Line-2",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,449 L0.5,0.5",
    id: "Line-2",
    stroke: "#00D8FF",
    strokeWidth: 2.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00D8FF",
    strokeWidth: 23,
    transform: "translate(229.500000, 241.500000) rotate(90.000000) translate(-229.500000, -241.500000) ",
    cx: 229.5,
    cy: 241.5,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    transform: "translate(229.500000, 241.500000) rotate(90.000000) translate(-229.500000, -241.500000) ",
    cx: 229.5,
    cy: 241.5,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00D8FF",
    strokeWidth: 23,
    transform: "translate(229.661197, 242.002830) rotate(30.000000) translate(-229.661197, -242.002830) ",
    cx: 229.661197,
    cy: 242.00283,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    transform: "translate(229.661197, 242.002830) rotate(30.000000) translate(-229.661197, -242.002830) ",
    cx: 229.661197,
    cy: 242.00283,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00D8FF",
    strokeWidth: 23,
    transform: "translate(229.661197, 242.002830) rotate(-30.000000) translate(-229.661197, -242.002830) ",
    cx: 229.661197,
    cy: 242.00283,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    transform: "translate(229.661197, 242.002830) rotate(-30.000000) translate(-229.661197, -242.002830) ",
    cx: 229.661197,
    cy: 242.00283,
    rx: 86.5,
    ry: 229.5
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-2",
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 20,
    strokeDasharray: 10,
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#FFFFFF",
    cx: 231,
    cy: 243,
    r: 39
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f77432ee46748fb5ada15762c0b86fb6.svg";
export { ForwardRef as ReactComponent };